/**
 * Renders a single chat bubble for a message. Pure presentational; receives
 * `mine` flag to swap colors and alignment. Extracted from MessageDrawer.
 */
export default function MessageBubble({ message, mine }) {
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`}>
      <div className={`max-w-[80%] border-2 border-ink p-3 ${mine ? "bg-acid" : "bg-white"}`}>
        <div className="font-mono text-[10px] uppercase tracking-widest mb-1">
          {message.from_name} · {message.from_role}
        </div>
        <div className="text-sm break-words whitespace-pre-wrap">{message.text}</div>
        <div className="font-mono text-[9px] mt-1 opacity-60">
          {new Date(message.created_at).toLocaleString()}
        </div>
      </div>
    </div>
  );
}
